// Traducciones específicas para la página de financiamiento - Español
export const financingEs = {
  hero: {
    title: 'Financiamiento',
    description:
      'Completa el formulario para solicitar información sobre nuestras opciones de financiamiento.',
  },
  form: {
    firstName: 'Nombre',
    lastName: 'Apellido',
    email: 'Email',
    phone: 'Teléfono',
    rut: 'RUT',
    birthDate: 'Fecha de Nacimiento',
    employmentType: 'Actividad Laboral',
    monthlyIncome: 'Renta Líquida Mensual',
    vehicleInterest: 'Vehículo de interés',
    vehicleSearchPlaceholder: 'Buscar vehículo',
    noVehiclesAvailable: 'No hay vehículos disponibles actualmente',
    downPayment: 'Monto Pie',
    message: 'Mensaje o información adicional',
    submit: 'Enviar Información',
  },
  employmentTypes: {
    employeeNonProfessional: 'Dependiente NO Profesional',
    employeeProfessional: 'Dependiente Profesional',
    selfEmployedNonProfessional: 'Independiente NO Profesional',
    selfEmployedProfessional: 'Independiente Profesional',
    retired: 'Jubilado',
    other: 'Otros',
  },
  info: {
    optionsTitle: 'Opciones de Financiamiento',
    benefitsTitle: 'Beneficios de nuestro financiamiento',
    benefitsList: {
      item1: 'Tasas de interés competitivas',
      item2: 'Plazos flexibles de 12 a 60 meses',
      item3: 'Aprobación rápida',
      item4: 'Mínimos requisitos',
    },
    requirementsTitle: 'Requisitos básicos',
    requirementsList: {
      item1: 'Identificación oficial vigente',
      item2: 'Comprobante de domicilio',
      item3: 'Comprobante de ingresos',
      item4: 'Historial crediticio favorable',
    },
    directContactTitle: 'Contacto Directo',
    emailLabel: 'Email',
    phoneLabel: 'Teléfono',
  },
  embed: {
    infoTitle: 'Opciones de financiamiento',
    benefits: ['Aprobación rápida', 'Tasas competitivas', 'Plazos flexibles', 'Sin letra chica'],
    requirementsTitle: 'Requisitos',
    requirements: ['Cédula de identidad', 'Liquidación de sueldo', 'Comprobante de domicilio', 'Antigüedad laboral mínima'],
    contactTitle: 'Contacto directo',
  },
};
